import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Tippy from '~components/tippy';
import IconRound from '~containers/booking/booking-details/icon-round';
import { BOOKING_STATUS } from '~graphql-types';
import {
  BasicCirclePast,
  BasicCircleResident,
  BookingConfirmedFilled,
  BookingHoldingFilled,
} from '~svg-components';

const useStyles = makeStyles(
  () => ({
    statusIcon: {
      position: 'absolute',
      right: -4,
      bottom: -4,
      boxShadow: '0 2px 4px 0 rgba(51, 53, 50, 0.16)',
    },
  }),
  { name: 'StudentAvatarIcon' }
);

const StudentAvatarIcon = React.forwardRef((props, ref) => {
  const { t } = useTranslation(['student', 'graphql']);
  const { status, StatusIconProps = { size: 24 }, ...otherProps } = props;

  const classes = useStyles();

  let bgColor = '';
  let SvgComponent = undefined;

  switch (status) {
    case BOOKING_STATUS.RESIDENT: {
      bgColor = 'violet';
      SvgComponent = BasicCircleResident;
      break;
    }
    case BOOKING_STATUS.BOOKING_COMPLETED:
    case BOOKING_STATUS.BOOKING_CONFIRMED: {
      bgColor = 'green';
      SvgComponent = BookingConfirmedFilled;
      break;
    }
    case BOOKING_STATUS.APPLIED:
    case BOOKING_STATUS.ROOM_SELECTED:
    case BOOKING_STATUS.SELECTION_COMPLETED:
    case BOOKING_STATUS.TERMS_ACCEPTED: {
      bgColor = 'orange';
      SvgComponent = BookingHoldingFilled;
      break;
    }
    case BOOKING_STATUS.PAST: {
      bgColor = 'grey99';
      SvgComponent = BasicCirclePast;
      break;
    }
    case BOOKING_STATUS.ENQUIRY:
    case BOOKING_STATUS.CANCELLED:
    case BOOKING_STATUS.EXPIRED:
    default:
      return;
  }

  return (
    <Tippy
      ref={ref}
      content={t(`graphql:booking_status.${status}`)}
      theme="tooltip"
      {...otherProps}
    >
      <IconRound bgcolor={bgColor} className={classes.statusIcon} {...StatusIconProps}>
        <SvgComponent
          color="white"
          style={{
            width: StatusIconProps.size / 2,
            height: StatusIconProps.size / 2,
          }}
        />
      </IconRound>
    </Tippy>
  );
});

StudentAvatarIcon.propTypes = {
  status: PropTypes.string,
  StatusIconProps: PropTypes.object,
};

StudentAvatarIcon.defaultProps = {
  StatusIconProps: {},
};

export default StudentAvatarIcon;
